export default __webpack_public_path__ + "static/wayne-and-vicky-af2c15c3cdd6b0f4cbfa892a239bb41e.webp";